import { setCookie } from 'cookies-next';

const TOKEN_TTL_MS = 48 * 60 * 60 * 1000;

export const saveAuthCookie = (token: string) => {
  const isProduction = process.env.NEXT_PUBLIC_ENVIRONMENT === 'production';
  const onLemonDomain = window.location.hostname.endsWith('lemon.io');

  setCookie(
    'authDomainSSO',
    JSON.stringify({
      token,
      environment: isProduction ? 'production' : 'integration',
    }),
    {
      expires: new Date(Date.now() + TOKEN_TTL_MS),
      ...(onLemonDomain && { domain: 'lemon.io' }),
    }
  );
};
